import React from 'react';
import PropTypes from 'prop-types';
import TotalsRow, { TotalsRowDescription, TotalsRowValue } from '../TotalsRow';
import formatCurrency from '@afosto/utils/formatCurrency';

const ServiceCostTotalsRow = ({ serviceCost, currency }) => {
  const percentageValue = serviceCost.is_percentage ? (serviceCost?.total ?? 0) / 100 : 0;

  return (
    <TotalsRow key={serviceCost.description}>
      <TotalsRowDescription variant="body1">{serviceCost?.description}</TotalsRowDescription>
      <TotalsRowValue variant="subtitle2">
        {serviceCost.is_percentage
          ? ` ${formatCurrency(
              percentageValue > 0 ? percentageValue * -1 : percentageValue,
              currency,
            )}`
          : ` ${formatCurrency(serviceCost?.total / 100, currency)}`}
      </TotalsRowValue>
    </TotalsRow>
  );
};

ServiceCostTotalsRow.propTypes = {
  serviceCost: PropTypes.object.isRequired,
  currency: PropTypes.string,
};

ServiceCostTotalsRow.defaultProps = {
  currency: 'EUR',
};

export default ServiceCostTotalsRow;
